import {t} from "i18next";
import {
    CARD_HIGHLIGHT_COLOR,
    EVENT_REFRESH_LIBRARY_LIST,
    KEY_FILE_DIR,
    SYS_CONFIG_KEY_THEME,
    THEME_DARK
} from "@/Const";
import {base64ToBlob, formatDate, getFileName, getFileNameExt, getItem, getUrlQueryParam} from "@/utils";
import {ipcInvoke} from "@/common/ipc";
import {getEmbedLink} from "../@excalidraw/packages/excalidraw/element/embeddable";
import {toValidURL} from "../@excalidraw/packages/excalidraw/data/url";
import {postMessage} from "@/common/event";
import {getCardDoc, getCardDocList, getCardList} from "@model/card";

/**
 * 获取card的标题
 */
export function getCardTitle0(item:any){
    if (!item)return '';
    let szName = item.name+'';
    if (item.type == 'card' && (szName == t("Untitled") || szName == '' || item.hasTitle == false)){
        if (item.thumbHtml){
            const div = document.createElement('div');
            div.innerHTML = item.thumbHtml;
            for (let i=0;i<div.childNodes.length;i++){
                szName = div.childNodes[i].textContent+'';
                if (szName){
                    break;
                }
            }
        }
    }
    if (!szName){
        szName = t("Untitled");
    }
    return szName;
}

export function getYoutubeThumbUrlByUrl(szUrl:any){
    const src = getEmbedLink(toValidURL(szUrl || ""));
    return `https://img.youtube.com/vi/${src?.videoId}/0.jpg`
}

/**
 * 滚动元素到中间
 * @param element
 */
export function scrollElementToMiddle(element,parentScrollView) {
    const elementRect = element.getBoundingClientRect(); // 获取元素的大小及其相对于视口的位置
    const viewportHeight = window.innerHeight; // 获取视口的高度
    const scrollToY = elementRect.top - (viewportHeight - elementRect.height) / 2; // 计算滚动到的Y坐标

    parentScrollView.scrollTo({
        top: scrollToY,
        behavior: 'smooth' // 实现平滑滚动
    });
}


export const detectNodeTypeArr = ['taskList', 'bulletList', 'orderedList']
// 遍历拿到hightlight内容 暂时不处理block部分
function getHighlightRelation(editor,pos) {
    const resolvedPos = editor?.state.doc.resolve(pos);
    const parentNode = resolvedPos.node(resolvedPos.depth - 1);
    const grandNode = resolvedPos.node(resolvedPos.depth - 2);
    const greatGrandNode = resolvedPos.node(resolvedPos.depth - 3);
    if (detectNodeTypeArr.includes(parentNode?.type?.name) && parentNode.attrs.blockHighlight) {
        return true
    }
    if (detectNodeTypeArr.includes(grandNode?.type?.name) && grandNode.attrs.blockHighlight) {
        return true
    }
    if (detectNodeTypeArr.includes(greatGrandNode?.type?.name) && greatGrandNode.attrs.blockHighlight) {
        return true
    }
    return false;
}

/**
 * 获取card的所有高亮....
 * @param editor
 */
export function getAllHighlightContent(editor) {
    let content = []
    let colorArr = []
    let szDefaultColor = "#FCEC96";
    editor?.state?.doc?.descendants((node, pos) => {
        if (node.attrs?.highlightImgUrl) {
            content.push({
                listId: crypto.randomUUID(),
                type: node.type.name,
                color: szDefaultColor,
                content: node.attrs?.highlightImgUrl,
                pos: pos, //即start
                end: pos + node.nodeSize,
                id: node.attrs?.id, //生成唯一性link
                selectStatus: false,
                editStatus: false,
                noteText: node.attrs?.noteText, // 笔记,
                node: node,
            })
            colorArr.push(szDefaultColor)
            return
        }
        if (node.attrs?.blockHighlight) {
            // 块内容默认必然是黄色的
            content.push({
                listId: crypto.randomUUID(),
                type: node.type.name,
                color: szDefaultColor,
                content: node.textContent || '',
                pos: pos, //即start
                end: pos + node.nodeSize,
                id: node.attrs?.id, //生成唯一性link
                node: node,
                selectStatus: false,
                editStatus: false,
                noteText: node.attrs?.noteText, // 笔记,
            })
            colorArr.push(szDefaultColor)
            return
        }
        if (getHighlightRelation(editor,pos)) {
            return;
        }


        node?.marks.forEach(mark => {
            if (mark.type.name === 'highlight') {
                // 连续mark合并
                if(mark.attrs?.id===content.at(-1)?.id){
                    content[content.length-1].content=`${content[content.length-1].content}\n${node?.text || ''}`
                    content[content.length-1].end=pos + node?.text?.length
                }else{
                    content.push({
                        listId: crypto.randomUUID(),
                        type: 'text',
                        color: mark.attrs?.color,
                        content: node?.text || '',
                        pos: pos, //即start
                        end: pos + node?.text?.length,
                        id: mark.attrs?.id, //生成唯一性link
                        selectStatus: false,
                        noteText: mark.attrs?.noteText, // 笔记,
                        editStatus: false,
                        node: mark
                    })
                    colorArr.push(mark.attrs?.color)
                }
            }
        })
    });
    const uniqueColorArr = [...new Set(colorArr)];

    return {
        content: content,
        colorArr: sortColorArr(uniqueColorArr)
    }
}

function sortColorArr(colorArr) {
    const arraySort =  CARD_HIGHLIGHT_COLOR.filter(item => colorArr.includes(item.usedColor));
    const arrayNewColors:any[] = [];
    arraySort.forEach(p=>{
        arrayNewColors.push(p.usedColor);
    })
    return arrayNewColors;
}

function isDarkMode(){
    return localStorage.getItem(SYS_CONFIG_KEY_THEME) == THEME_DARK;
}

/**
 * 更新mindmap的图标
 */
export function updateMindmapLinkIcon(){
    setTimeout(()=>{
        const arraySvgs = document.getElementsByTagName('svg');
        for (let i=0;i<arraySvgs.length;i++){
            const item = arraySvgs[i];
            const t = item.getAttribute('t');
            if (t == '1711935375590'){
                item.setAttribute('viewBox','0 0 17 17');
                item.setAttribute('fill','transparent');
                item.innerHTML = '<g id="Group 427322405">\n' +
                    '<g id="Frame 1321315478" clip-path="url(#clip0_2_1550)">\n' +
                    '<g id="Group 427322863">\n' +
                    `<rect id="Rectangle 34626409" x="1.53506" y="0.6" width="13.8" height="14.8" rx="1.4" stroke="${isDarkMode()?'#dddddd':'#333333'}" stroke-width="1.2"/>\n` +
                    `<path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M4.48848 4.53726C4.48848 4.20588 4.75711 3.93726 5.08848 3.93726H7.48848C7.81985 3.93726 8.08848 4.20588 8.08848 4.53726C8.08848 4.86863 7.81985 5.13726 7.48848 5.13726H5.08848C4.75711 5.13726 4.48848 4.86863 4.48848 4.53726ZM4.48848 8.0021C4.48848 7.67073 4.75711 7.4021 5.08848 7.4021H11.7816C12.113 7.4021 12.3816 7.67073 12.3816 8.0021C12.3816 8.33347 12.113 8.6021 11.7816 8.6021H5.08848C4.75711 8.6021 4.48848 8.33347 4.48848 8.0021ZM5.08848 10.863C4.75711 10.863 4.48848 11.1317 4.48848 11.463C4.48848 11.7944 4.75711 12.063 5.08848 12.063H11.7816C12.113 12.063 12.3816 11.7944 12.3816 11.463C12.3816 11.1317 12.113 10.863 11.7816 10.863H5.08848Z" fill="${isDarkMode()?'white':'#333333'}"/>\n` +
                    '</g>\n' +
                    '</g>\n' +
                    '</g>\n' +
                    '<defs>\n' +
                    '<clipPath id="clip0_2_1550">\n' +
                    '<rect width="16" height="16" fill="white" transform="translate(0.435059)"/>\n' +
                    '</clipPath>\n' +
                    '</defs>'
            }else if (t == '1624174958075'){
                item.setAttribute('fill',isDarkMode()?'#dddddd':'#565656')
            }
        }
    },20)
}

export function readImageBase64FromClipboard(htmlElement){
    return new Promise(resolve => {
        htmlElement?.focus();
        setTimeout(()=>{
            navigator.clipboard.read().then(async (clipboardItems) => {
                for (const clipboardItem of clipboardItems) {
                    for (const type of clipboardItem.types) {
                        if (type.startsWith('image/')) {
                            const blob = await clipboardItem.getType(type);
                            const reader = new FileReader();

                            reader.onload = async function(event) {
                                const szBase64 = event.target.result;
                                if (szBase64){
                                    resolve(szBase64);
                                }else{
                                    resolve('');
                                }
                            };
                            reader.readAsDataURL(blob); // 转换图片为DataURL格式
                            break;
                        }
                    }
                }
            });
        },100)

    })

}



export function setRootPostionFixed(){
    const divRoot = document.getElementById('root');
    if (divRoot){
        divRoot.style.position = 'fixed';
    }
}

export function resetRootPostionNormal(){
    const divRoot = document.getElementById('root');
    if (divRoot){
        divRoot.style.position = 'fixed';//'inherit';
    }
}


export function getBaiduVideoNameByUrl(szUrl){
    if (!szUrl)return '';
    let szName = getUrlQueryParam(szUrl,'path');
    if (szName){
        szName = getFileName(decodeURIComponent(szName));
    }
    return szName;
}

export async function copyImageFullPathToClipboard(szImagePath:any,textString:any){
    document.body.focus();
    setTimeout(async ()=>{
        const szBase64 = await ipcInvoke('read-file-base64',{filePath:szImagePath});
        const szExt = 'png'//getFileNameExt(szImagePath);//仅支持PNG。。。。。。
        const szImgBase64 = `data:image/${szExt};base64,${szBase64}`;

        const szType = 'image/'+szExt
        const blob = base64ToBlob(szImgBase64,szType);
        const item = new ClipboardItem({[blob.type]:blob})
        const datas = [item];
        // if (textString){
        //     const textBlob = new Blob([textString],{type:'text/plain'})
        //     const itemText = new ClipboardItem({'text/plain':textBlob});
        //     datas.push(itemText)
        // }
        await navigator.clipboard.write(datas);//仅支持PNG。。。。。。//仅支持PNG。。。。。。//仅支持PNG。。。。。。//仅支持PNG。。。。。。//仅支持PNG。。。。。。//仅支持PNG。。。。。。//仅支持PNG。。。。。。//仅支持PNG。。。。。。//仅支持PNG。。。。。。//仅支持PNG。。。。。。//仅支持PNG。。。。。。
    },100);

}

export async function copyImageToClipboard(szCapturePath:any,textString:any){
    const szFileName = localStorage.getItem(KEY_FILE_DIR)+szCapturePath;
    const szBase64 = await ipcInvoke('read-file-base64',{filePath:szFileName});
    const szImgBase64 = `data:image/${getFileNameExt(szCapturePath)};base64,${szBase64}`;

    const blob = base64ToBlob(szImgBase64,'image/png');
    const item = new ClipboardItem({'image/png':blob})
    const datas = [item];
    // if (textString){
    //     const textBlob = new Blob([textString],{type:'text/plain'})
    //     const itemText = new ClipboardItem({'text/plain':textBlob});
    //     datas.push(itemText)
    // }

    await navigator.clipboard.write(datas);
    window.messageInfo(t("ScreenshotCopiedToClipboard"))
}

